module.exports = __webpack_public_path__ + "static/img/ABOUT-US.0903b4d5.jpg";